<ng-template #helpTemplate> <div [innerHtml]="html"></div></ng-template>

<mdb-icon *ngIf="html" [ngClass]="class" fas icon="question-circle" [mdbTooltip]="helpTemplate"></mdb-icon>
<mdb-icon *ngIf="templateId" [ngClass]="class" fas icon="question-circle" [mdbTooltip]="templateId"></mdb-icon>
<mdb-icon *ngIf="!templateId && !html" [ngClass]="class" fas icon="question-circle"></mdb-icon>